import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=6b3e8681&scoped=true&"
import script from "./building.js?vue&type=script&lang=js&"
export * from "./building.js?vue&type=script&lang=js&"
import style0 from "./building.scss?vue&type=style&index=0&id=6b3e8681&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e8681",
  null
  
)

export default component.exports